// @core/api/endpoints/product/list_products_by_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductsResponse,
} from '../../../types/product';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/product';

/**
 * List products by category
 * Returns products belonging to a specific category. Supports filtering by status.
 * @public This endpoint does not require authentication
 */
export async function ListProductsByCategory(
  category_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProductsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/categories/:category_id/products`;
  requestPath = requestPath.replace(':category_id', encodeURIComponent(category_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListProductsResponse>(requestPath, { ...requestOptions, params });
}
